import React, { useEffect } from 'react';
import { Hero } from '../components/sales/Hero';
import { StickyBar } from '../components/sales/StickyBar';
import { ProblemSection } from '../components/sales/ProblemSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { WhatYouGet } from '../components/sales/WhatYouGet';
import { Testimonials } from '../components/sales/Testimonials';
import { PriceSection } from '../components/sales/PriceSection';
import { FAQ } from '../components/sales/FAQ';
import { Footer } from '../components/sales/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-body text-navy antialiased selection:bg-gold/30 pb-20 md:pb-0" data-id="element-206">
      <StickyBar data-id="element-207" />
      <Hero data-id="element-208" />
      <ProblemSection data-id="element-209" />
      <SolutionSection data-id="element-210" />
      <WhatYouGet data-id="element-211" />
      <Testimonials data-id="element-212" />
      <PriceSection data-id="element-213" />
      <FAQ data-id="element-214" />
      <Footer data-id="element-215" />
    </div>;
}